<template>
  <div class="space-y-6">
    <header>
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
        <i class="far fa-ban text-primary-500 mr-2" />
        Negative Keywords
      </h2>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Lists scoped to this business. They become available to attach to any Location below.
      </p>
    </header>

    <ScopeListsManager
      scope="business"
      :account-id="accountId"
      :business-id="businessId"
      :csrf-token="csrfToken" />
  </div>
</template>

<script setup>
import ScopeListsManager from './scope_lists_manager.vue'

defineProps({
  businessId: { type: String, required: true },
  accountId: { type: String, required: true },
  csrfToken: { type: String, required: true }
})
</script>
